import { Subscriptions } from '@ynap/api-utils';
import apiAction from '@ynap/api-fetch-action';
import { redirectToLogin } from '@ynap/redirect-utils';

export default function updateSubscriptions(subscriptions, { accessKey, email }) {
    return (dispatch, getState) => {
        const { locale, config, uberToken } = getState();
        // TODO remove config backwards-compatibility
        const { clientRequest } = config.head || config;
        const { country } = locale;
        const { brandId } = config.watsonService || config.global.application;
        const { baseUrl, clientId } = config.watsonService || config.global.services.commerce;

        if (!clientId) {
            return redirectToLogin(locale.id);
        }

        if (!(accessKey && email) && !uberToken) {
            return redirectToLogin(locale.id);
        }

        const options = {
            baseUrl,
            brandId,
            clientId,
            country,
            subscriptions,
        };

        if (accessKey && email) {
            options.accessKey = encodeURIComponent(accessKey);
            options.email = encodeURIComponent(email.replace(/\s/, '+'));
        } else if (uberToken && clientId) {
            options.uberToken = uberToken;
        }

        const request = Subscriptions.putUserSubscriptions(options);

        return dispatch(
            apiAction(request, 'UPDATE_USER_SUBSCRIPTIONS', null, { reqTimeout: clientRequest.timeout, reqDelay: clientRequest.delay, subscriptions }),
        );
    };
}
